// Modules
import { Loading } from '@dasa-health/components-react'
import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'

// Application
import { TokenType } from 'typings/index'
import { TIME_FOR_ENABLE_RESEND_TOKEN } from 'constants/app'

// Components
import { ResendToken } from '../ValidateToken/ResendToken'
import { Token } from '../ValidateToken/Token'
import { StyledForm } from './styles'
import { SignUpHelpTextModal } from 'redesign/components/atoms/SignUpHelpTextModal'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { SignUpFooter } from 'redesign/components/molecules/SignUpFooter'

export interface ValidateTokenInitial {
    token: TokenType
}

export interface IValidateDestinationToken {
    initialValues?: ValidateTokenInitial
    isDisableButton?: boolean
    isDestinationTaggin?: boolean
    handleSubmit: (values: { token: TokenType }) => Promise<void>
    handleResendToken: (destinationType: string) => Promise<void>
    isLoading: boolean
    fieldState: {
        status: string
        message: string
    }
    isDestinationMobile: boolean
    submitText?: string
    isLoadingButton?: boolean
    onMountResentAnalytics?: () => void
    showHelpModal?: boolean
    isOtp?: boolean
}

export const ValidateDestinationToken: React.FC<IValidateDestinationToken> = ({
    isLoading,
    fieldState,
    handleSubmit,
    isDisableButton,
    isDestinationTaggin,
    handleResendToken,
    isDestinationMobile,
    isLoadingButton,
    onMountResentAnalytics,
    submitText = 'Continuar',
    initialValues = { token: Array(6).fill(null) },
    showHelpModal = true,
    isOtp = false,
}) => {
    const [counter, setCounter] = useState(TIME_FOR_ENABLE_RESEND_TOKEN)
    const [showCounter, setShowCounter] = useState(true)
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        let unmount = false
        let counterTimer: ReturnType<typeof setTimeout>
        if (counter > 0) {
            counterTimer = setTimeout(() => {
                if (!unmount) {
                    setCounter(counter - 1)
                }
            }, 1000)
        }

        if (counter === 0) {
            setShowCounter(false)
        }

        return () => {
            unmount = true
            clearTimeout(counterTimer)
        }
    }, [counter, fieldState])

    const getClassByStatus = (status: string) =>
        status ? `validate-form__field validate-form__field--${status}` : 'validate-form__field'

    const resendToken = async () => {
        if (isDestinationMobile) {
            return handleDestinationToken('SMS')
        }
        return handleDestinationToken('EMAIL')
    }

    const handleDestinationToken = async (value: string) => {
        await handleResendToken(value)
        setShowCounter(true)
        setCounter(TIME_FOR_ENABLE_RESEND_TOKEN)
    }

    return (
        <Formik initialValues={initialValues} onSubmit={values => handleSubmit(values)}>
            {({ values, setFieldValue, submitForm }) => (
                <StyledForm className="scenario-whatsapp">
                    {showHelpModal && (
                        <>
                            <SignUpModal
                                setShowModal={() => {
                                    setShowModal(!showModal)
                                }}
                                showModal={showModal}
                                title="Por que preciso fazer isso?"
                            >
                                <p>
                                    Ao entrar no Nav Dasa, você poderá acessar todo o seu histórico de saúde e dados pessoais coletados
                                    no ecossistema Dasa.
                                </p>
                                <p>
                                    Através deste código, posso verificar sua identidade e garantir que o acesso às suas informações
                                    está seguro.
                                </p>
                            </SignUpModal>
                            <SignUpHelpTextModal onClick={() => setShowModal(true)}>Por que preciso fazer isso?</SignUpHelpTextModal>
                        </>
                    )}

                    <Form autoComplete="one-time-code">
                        <Token
                            fieldState={fieldState}
                            getClassByStatus={getClassByStatus}
                            isSubmitting={isLoading}
                            setFieldValue={setFieldValue}
                            submitForm={submitForm}
                            values={values}
                        />
                        <div className="form__validate-form__resend-token">
                            {isLoading ? (
                                <Loading data-testid="loading-test" size={24} strokeWidth={3} />
                            ) : (
                                <ResendToken
                                    count={counter}
                                    dataTestButton={'resend-token'}
                                    dataTestCounter={'counter-test'}
                                    isCounter={showCounter}
                                    isDestinationMobile={isDestinationMobile}
                                    isOtp={isOtp}
                                    onMountResentAnalytics={onMountResentAnalytics}
                                    onResendToken={resendToken}
                                    onResendTokenWhatsapp={() => handleDestinationToken('WHATSAPP')}
                                />
                            )}
                        </div>
                        <SignUpFooter
                            isSubmitButtonDisabled={!isDisableButton}
                            isSubmitButtonLoading={isLoadingButton}
                            passwordResetFlow={isDestinationTaggin}
                            submitButtonText={submitText}
                        />
                    </Form>
                </StyledForm>
            )}
        </Formik>
    )
}
